<template>
  <section class="downtime-statuses">
    <div class="section-header">
      <h4>Простои по точкам</h4>
      <button type="button" class="refresh-button" :disabled="loading" @click="load">Обновить</button>
    </div>
    <p v-if="loading" class="state">Загрузка статусов...</p>
    <p v-else-if="error" class="state error">{{ error }}</p>
    <div v-else class="points-grid">
      <div v-for="(point, index) in items" :key="point.route_point_id" class="point-card">
        <div class="point-title">
          <strong>Точка {{ index + 1 }}</strong>
          <span class="tag" :style="statusStyle(point)">{{ downtimeStatusMeta(point).label }}</span>
        </div>
        <div>{{ point.warehouse_name || 'Склад не указан' }}</div>
        <div class="point-meta">{{ formatOperation(point) }} · план {{ formatNaiveDate(point.planned_date) }}</div>
        <div class="point-meta">Факт прибытия: {{ formatNaiveDate(point.arrival_time) }}</div>
        <div class="point-meta">Факт убытия: {{ formatNaiveDate(point.departure_time) }}</div>
        <div v-if="point.actual_start_operation_time || point.actual_end_operation_time" class="point-meta">
          Операция: {{ formatNaiveDate(point.actual_start_operation_time) }} - {{ formatNaiveDate(point.actual_end_operation_time) }}
        </div>
        <div v-if="point.downtime_classification !== 'upcoming' && point.downtime_lifecycle === 'open'" class="point-meta">
          Простой: {{ formatHours(point.overdue_hours) }}
        </div>
      </div>
      <p v-if="!items.length" class="state">Точки маршрута не найдены</p>
    </div>
  </section>
</template>

<script>
import { ref, watch } from 'vue'
import { fetchTripDowntimeStatuses } from '@/backend/downtimesApi'
import { downtimeStatusMeta, formatHours, formatNaiveDate, formatOperation } from '@/pages/downtimes/downtimeOptions.mjs'

export default {
  name: 'TripDowntimeStatuses',
  props: { tripId: { type: Number, required: true } },
  setup(props) {
    const items = ref([])
    const loading = ref(false)
    const error = ref('')
    const load = async () => {
      loading.value = true
      error.value = ''
      try {
        const data = await fetchTripDowntimeStatuses(props.tripId)
        items.value = Array.isArray(data?.items) ? data.items : []
      } catch {
        error.value = 'Не удалось загрузить статусы простоев'
      } finally {
        loading.value = false
      }
    }
    watch(() => props.tripId, load, { immediate: true })
    const statusStyle = (point) => {
      const meta = downtimeStatusMeta(point)
      return { color: meta.color, backgroundColor: meta.background }
    }
    return { items, loading, error, load, statusStyle, downtimeStatusMeta, formatHours, formatNaiveDate, formatOperation }
  },
}
</script>

<style scoped>
.downtime-statuses { margin-top: 15px; padding: 16px; border: 1px solid #d0d5dd; border-radius: 10px; }
.section-header, .point-title { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.section-header h4 { margin: 0; }
.refresh-button { padding: 5px 9px; border: 1px solid #007bff; border-radius: 4px; background: #fff; color: #007bff; cursor: pointer; }
.refresh-button:disabled { cursor: wait; opacity: .6; }
.points-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 10px; margin-top: 12px; }
.point-card { padding: 10px; border: 1px solid #eaecf0; border-radius: 7px; }
.point-meta, .state { margin: 7px 0 0; color: #667085; font-size: 13px; }
.state.error { color: #b42318; }
.tag { display: inline-block; padding: 2px 7px; border-radius: 10px; font-size: 11px; font-weight: 700; }
</style>
